import { apiSite, api } from '@/api';

export function getAllSettings(params) {
    return api.get('/global_settings', { params });
}

export function changeSettings(data) {
    return api.post(`/global_settings`, data);
}
